import { skipToken, useQuery } from '@tanstack/react-query';

import { Workspaces } from '@air/api';
import { type Airror } from '@air/errors';
import { callAirApi } from '@air/utils-api';

import { ONE_DAY } from '~/constants/unitsOfTime';

export const DEFAULT_SETTINGS = 'DEFAULT_SETTINGS';

export type UseGetDefaultSettingsParams = NonNullable<Parameters<typeof Workspaces.ShortUrl.getDefaultSettings>[0]>;
export type ShortUrlDefaultSettingsResponse = Exclude<
  Awaited<ReturnType<typeof Workspaces.ShortUrl.getDefaultSettings>>,
  Airror
>;

export const getDefaultSettingsKey = (params: UseGetDefaultSettingsParams) => [DEFAULT_SETTINGS, params];

export const useGetDefaultSettings = (params: UseGetDefaultSettingsParams) =>
  useQuery({
    queryKey: getDefaultSettingsKey(params),
    queryFn: params.workspaceId
      ? () => callAirApi<ShortUrlDefaultSettingsResponse>(() => Workspaces.ShortUrl.getDefaultSettings(params))
      : skipToken,
    enabled: !!params.workspaceId,
    staleTime: ONE_DAY,
  });
